import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';

export enum IconType {
  cardView = 'cardView',
  listView = 'listView',
  user = 'user',
  cart = 'cart',
  listMenu = 'listMenu',
  search = 'search',
  close = 'close',
  back = 'back',
  rightArrow = 'rightArrow',
  upload = 'upload',
  success = 'success',
  error = 'error',
  document = 'document',
  refresh = 'refresh',
  paid = 'paid',
  time = 'time',
  inwork = 'inwork',
  checked = 'checked',
  newAddress = 'newAddress',
  trash = 'trash',
  minus = 'minus',
  plus = 'plus',
  favourites = 'favourites',
  audio = 'audio',
  kitchen = 'kitchen',
  home = 'home',
  downArrow = 'downArrow',
  upArrow = 'upArrow',
  sale = 'sale',
  arrowBack = 'arrowBack',
  arrowNext = 'arrowNext',
  compare = 'compare',
  topArrow = 'topArrow',
  bottomArrow = 'bottomArrow',
  description = 'description',
  specification = 'specification',
  reviews = 'reviews',
  related = 'related',
}

interface Props {
  icon: IconType;
  className?: string;
  viewBox?: string;
  fill?: string;
  title?: string;
  alt?: string;
  cursor?: string;
  marginLeft?: number;
  marginRight?: number;
  height?: number;
  width?: number;
  onClick?: any;
}

const icons = {
  cardView: () => (
    <path
      d="M8,0H2C0.9,0,0,0.9,0,2v6c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V2C10,0.9,9.1,0,8,0z M8,8H2l0-6h0h6V8z M8,12H2
	c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2v-6C10,12.9,9.1,12,8,12z M8,20H2l0-6h0h6V20z M20,0h-6c-1.1,0-2,0.9-2,2v6
	c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V2C22,0.9,21.1,0,20,0z M20,8h-6l0-6h0h6V8z M20,12h-6c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h6
	c1.1,0,2-0.9,2-2v-6C22,12.9,21.1,12,20,12z M20,20h-6l0-6h0h6V20z"
    />
  ),
  listView: () => (
    <path
      d="M0,1c0-0.6,0.4-1,1-1h20c0.6,0,1,0.4,1,1s-0.4,1-1,1H1C0.4,2,0,1.6,0,1z M21,8H1C0.4,8,0,8.4,0,9s0.4,1,1,1h20
	c0.6,0,1-0.4,1-1S21.6,8,21,8z M21,16H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h20c0.6,0,1-0.4,1-1S21.6,16,21,16z"
    />
  ),
  user: () => (
    <path
      d="M20,22c-0.6,0-1-0.4-1-1v-2c0-1.7-1.3-3-3-3H8c-1.7,0-3,1.3-3,3v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2c0-2.8,2.2-5,5-5h8
	c2.8,0,5,2.2,5,5v2C21,21.6,20.6,22,20,22z M17,7c0-2.8-2.2-5-5-5S7,4.2,7,7s2.2,5,5,5S17,9.8,17,7z M15,7c0,1.7-1.3,3-3,3
	S9,8.7,9,7s1.3-3,3-3S15,5.3,15,7z"
    />
  ),
  cart: () => (
    <path
      d="M9,23.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S10.1,23.5,9,23.5z M22,21.5c0-1.1-0.9-2-2-2s-2,0.9-2,2s0.9,2,2,2
	S22,22.6,22,21.5z M9.7,17.5h9.7c1.5,0,2.7-1,3-2.4L24,6.7c0.1-0.3,0-0.6-0.2-0.8c-0.2-0.2-0.5-0.4-0.8-0.4H6.8L6,1.3
	C5.9,0.8,5.5,0.5,5,0.5H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h3.2L5,6.7c0,0,0,0.1,0,0.1l1.7,8.3C7,16.5,8.2,17.5,9.7,17.5
	C9.6,17.5,9.7,17.5,9.7,17.5z M21.8,7.5l-1.4,7.2c-0.1,0.5-0.5,0.8-1,0.8H9.7c-0.5,0-0.9-0.3-1-0.8L7.2,7.5H21.8z"
    />
  ),
  listMenu: () => (
    <path
      id="Icon"
      transform="translate(620.5 361.5)"
      d="M-600-354.5h-17c-0.6,0-1-0.4-1-1s0.4-1,1-1h17c0.6,0,1,0.4,1,1
    S-599.4-354.5-600-354.5z M-599-349.5c0-0.6-0.4-1-1-1h-17c-0.6,0-1,0.4-1,1s0.4,1,1,1h17C-599.4-348.5-599-348.9-599-349.5z
     M-599-343.5c0-0.6-0.4-1-1-1h-17c-0.6,0-1,0.4-1,1s0.4,1,1,1h17C-599.4-342.5-599-342.9-599-343.5z"
    />
  ),
  search: () => (
    <path
      d="M22.2,22.7C22,22.9,21.8,23,21.5,23c-0.3,0-0.5-0.1-0.7-0.3l-5-5.2c-1.5,1-3.2,1.6-5.1,1.6c-5,0-9.1-4.1-9.1-9
	c0-5,4.1-9,9.1-9c5,0,9.1,4.1,9.1,9c0,2.4-1,4.6-2.5,6.2l4.9,5.1C22.6,21.7,22.6,22.3,22.2,22.7z M10.6,17.1c3.9,0,7.1-3.2,7.1-7
	s-3.2-7-7.1-7c-3.9,0-7.1,3.2-7.1,7S6.7,17.1,10.6,17.1z"
    />
  ),
  close: () => (
    <>
      <defs>
        <style>{`.a{fill:none;}`}</style>
      </defs>
      <g transform="translate(-15 -22)">
        <g transform="translate(-251 -4515)">
          <rect
            className="a"
            width="28"
            height="28"
            transform="translate(266 4537)"
          />
        </g>
        <path
          d="M-2056.736,595.678l-7.071-7.071-7.072,7.071a1,1,0,0,1-1.413,0,1,1,0,0,1,0-1.415l7.071-7.071-7.071-7.071a1,1,0,0,1,0-1.415,1,1,0,0,1,1.413,0l7.072,7.071,7.071-7.071a1,1,0,0,1,1.415,0,1,1,0,0,1,0,1.415l-7.072,7.071,7.072,7.072a1,1,0,0,1,0,1.413,1,1,0,0,1-.708.293A.994.994,0,0,1-2056.736,595.678Z"
          transform="translate(2092.807 -551.192)"
        />
      </g>
    </>
  ),
  back: () => <path id="arrow" d="M5.5,12,0,6,5.5,0,7,1.4,2.7,6,7,10.6Z" />,
  rightArrow: () => (
    <path
      d="M4.5,10C4.2,10,4,9.9,3.8,9.7c-0.4-0.4-0.4-1,0-1.4L6.1,6L3.8,3.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3,3
	c0.4,0.4,0.4,1,0,1.4l-3,3C5,9.9,4.8,10,4.5,10z"
    />
  ),
  upload: () => (
    <path
      d="M22,16.8v5c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1v-5c0-0.6,0.4-1,1-1s1,0.4,1,1v4h16v-4c0-0.6,0.4-1,1-1S22,16.2,22,16.8z
	 M5.3,10c0.3,0,0.5-0.1,0.7-0.3l5-4.9l0,11.6c0,0.6,0.4,1,1,1c0,0,0,0,0,0c0.6,0,1-0.5,1-1l0-11.6l5.1,4.9c0.4,0.4,1,0.4,1.4,0
	c0.4-0.4,0.4-1,0-1.4l-6.8-6.5c-0.1-0.1-0.2-0.1-0.3-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0
	c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0L4.6,8.3c-0.4,0.4-0.4,1,0,1.4C4.7,9.9,5,10,5.3,10z"
    />
  ),
  success: () => (
    <path
      d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2
	V9z"
    />
  ),
  error: () => (
    <path
      d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2
	V9z"
    />
  ),
  document: () => (
    <path d="M14,2H6C4.9,2,4,2.9,4,4l0,16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8L14,2z M6,20V4h7v5h5v11H6z" />
  ),
  refresh: () => (
    <path
      d="M17.6,6.3c-3.1-3.1-8.2-3.1-11.3,0s-3.1,8.2,0,11.3s8.2,3.1,11.3,0c1-1,1.7-2.3,2.1-3.7h-2.1c-1.1,3.1-4.5,4.8-7.7,3.7
	S5.2,13.1,6.3,10C7.2,7.6,9.5,6,12,6c1.6,0,3.1,0.6,4.2,1.8L13,11h7V4L17.6,6.3z"
    />
  ),
  paid: () => (
    <path
      d="M12,22.5C6.2,22.5,1.5,17.8,1.5,12C1.5,6.2,6.2,1.5,12,1.5c5.8,0,10.5,4.7,10.5,10.5C22.5,17.8,17.8,22.5,12,22.5z M12,3.5
	c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5C20.5,7.3,16.7,3.5,12,3.5z M11.5,15.2l5.3-5
	c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-4.6,4.3l-2-2.1c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l2.7,2.8
	c0.2,0.2,0.5,0.3,0.7,0.3C11,15.5,11.3,15.4,11.5,15.2z"
    />
  ),
  time: () => (
    <path
      d="M12,22.5C6.2,22.5,1.5,17.8,1.5,12C1.5,6.2,6.2,1.5,12,1.5c5.8,0,10.5,4.7,10.5,10.5C22.5,17.8,17.8,22.5,12,22.5z M12,3.5
	c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5C20.5,7.3,16.7,3.5,12,3.5z M16.5,14.5c0.2-0.5,0-1.1-0.4-1.3
	l-3.2-1.6v-5c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.6c0,0.4,0.2,0.7,0.6,0.9l3.7,1.9c0.1,0.1,0.3,0.1,0.4,0.1C16,15,16.3,14.8,16.5,14.5z"
    />
  ),
  inwork: () => (
    <path
      d="M17,4h-1c0-1.1-0.9-2-2-2h-4C8.9,2,8,2.9,8,4H7C5.3,4,4,5.3,4,7v12c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3V7
	C20,5.3,18.7,4,17,4z M10,4h4v2h-4V4L10,4z M18,19c0,0.6-0.4,1-1,1H7c-0.6,0-1-0.4-1-1V7c0-0.6,0.4-1,1-1h1c0,1.1,0.9,2,2,2h4
	c1.1,0,2-0.9,2-2h1c0.6,0,1,0.4,1,1V19z"
    />
  ),
  checked: () => (
    <path
      d="M4.1,7.9a.908.908,0,0,1-.7-.3L.3,4.4A.967.967,0,0,1,.3,3,.967.967,0,0,1,1.7,3L4.1,5.4,9.3.2a.967.967,0,0,1,1.4,0,.967.967,0,0,1,0,1.4l-5.9,6A.779.779,0,0,1,4.1,7.9Z"
      transform="translate(0 0.1)"
    />
  ),
  newAddress: () => (
    <path
      d="M21.5,24h-6.2c-0.6,0-1-0.4-1-1v-5.8H9.7V23c0,0.6-0.4,1-1,1H2.5C1.7,24,1,23.4,1,22.6v-13C1,9.3,1.1,9,1.3,8.8l10-8.6
	l1.3,1.5L3,10.1V22h4.7v-5.8c0-0.6,0.4-1,1-1h6.7c0.6,0,1,0.4,1,1V22H21V9.8h2v12.8C23,23.4,22.3,24,21.5,24z M20,8V5h3V3h-3V0h-2v3
	h-3v2h3v3H20z"
    />
  ),
  trash: () => (
    <path
      d="M14,3.3h-2.6V2.7c0-1.1-0.9-2.1-2.1-2.1H6.7c-1.1,0-2.1,0.9-2.1,2.1v0.6H2C1.6,3.3,1.3,3.6,1.3,4S1.6,4.8,2,4.8h0.6v8.6
	c0,1.1,0.9,2.1,2.1,2.1h6.7c1.1,0,2.1-0.9,2.1-2.1V4.8H14c0.4,0,0.8-0.3,0.8-0.8S14.4,3.3,14,3.3z M6.1,2.7c0-0.3,0.3-0.6,0.6-0.6
	h2.7c0.3,0,0.6,0.3,0.6,0.6v0.6H6.1V2.7z M11.9,13.3c0,0.3-0.3,0.6-0.6,0.6H4.7c-0.3,0-0.6-0.3-0.6-0.6V4.8h7.8V13.3z M7.4,7.3v4
	c0,0.4-0.3,0.8-0.8,0.8s-0.8-0.3-0.8-0.8v-4c0-0.4,0.3-0.8,0.8-0.8S7.4,6.9,7.4,7.3z M10.1,7.3v4c0,0.4-0.3,0.8-0.8,0.8
	s-0.8-0.3-0.8-0.8v-4c0-0.4,0.3-0.8,0.8-0.8S10.1,6.9,10.1,7.3z"
    />
  ),
  favourites: () => (
    <path
      d="M12,22.1c-0.3,0-0.5-0.1-0.7-0.3L2.5,13c-1.2-1.2-1.9-2.9-1.9-4.6c0-1.7,0.7-3.4,1.9-4.6c2.5-2.5,6.7-2.5,9.2,0L12,4.2
	l0.4-0.4c1.2-1.2,2.9-1.9,4.6-1.9c0,0,0,0,0,0c1.7,0,3.4,0.7,4.6,1.9l0,0c2.5,2.5,2.5,6.7,0,9.2l-8.8,8.8C12.5,22,12.3,22.1,12,22.1
	z M7.1,3.9c-1.2,0-2.3,0.4-3.2,1.3C3,6.1,2.5,7.2,2.5,8.4c0,1.2,0.5,2.3,1.3,3.2l8.1,8.1l8.1-8.1c0.9-0.9,1.3-2,1.3-3.2
	c0-1.2-0.5-2.3-1.3-3.2l0,0c-0.8-0.9-2-1.3-3.2-1.3c0,0,0,0,0,0c-1.2,0-2.3,0.5-3.2,1.3l-1.1,1.1c-0.4,0.4-1,0.4-1.4,0l-1.1-1.1
	C9.4,4.3,8.2,3.9,7.1,3.9z"
    />
  ),
  audio: () => (
    <path
      d="M12,2C6.5,2,2,6.5,2,12v2v4v1c0,1.7,1.3,3,3,3h1c1.7,0,3-1.3,3-3v-3c0-1.7-1.3-3-3-3H4v-1c0-4.4,3.6-8,8-8s8,3.6,8,8v1h-2
	c-1.7,0-3,1.3-3,3v3c0,1.7,1.3,3,3,3h1c1.7,0,3-1.3,3-3v-1v-4v-2C22,6.5,17.5,2,12,2z M6,15c0.6,0,1,0.4,1,1v3c0,0.6-0.4,1-1,1H5
	c-0.6,0-1-0.4-1-1v-1v-3H6z M20,19c0,0.6-0.4,1-1,1h-1c-0.6,0-1-0.4-1-1v-3c0-0.6,0.4-1,1-1h2v3V19z"
    />
  ),
  kitchen: () => (
    <path
      d="M17,23H3c-1.1,0-2-0.9-2-2l0-3c0.1-4.1,0.6-8.2,1.4-12.2l0.1-0.6C1.9,4.3,1.4,3.3,1.1,2.3L0.7,1H18c2.1,0,3.5,0.9,4,2.6
	c0.7,3.5,1.1,7.1,1,10.7l0,0.1c-0.2,1.4-1,2.6-2.2,3.4L19,18.9V21C19,22.1,18.1,23,17,23z M3,18v3h14v-3c-0.1-6.7-1.3-13.4-2-15H3.5
	c0.2,0.4,0.4,0.8,0.7,1.1l0.4,0.5L4.3,6.1C3.6,10,3.1,14,3,18z M17.1,3c1,3,1.8,9,1.9,13.6l0.8-0.5c0.7-0.4,1.1-1.1,1.2-1.9
	c0-3.4-0.3-6.8-1-10.1C19.9,3.5,19.6,3,18,3H17.1z M11,15.7v-8c0-0.6-0.4-1-1-1s-1,0.4-1,1v8c0,0.6,0.4,1,1,1S11,16.3,11,15.7z"
    />
  ),
  home: () => (
    <path
      d="M21,23H3c-0.6,0-1-0.4-1-1V9c0-0.3,0.1-0.6,0.4-0.8l9-7c0.4-0.3,0.9-0.3,1.2,0l9,7C21.9,8.4,22,8.7,22,9v13
	C22,22.6,21.6,23,21,23z M4,21h16V9.5l-8-6.2L4,9.5V21z"
    />
  ),
  downArrow: () => (
    <path
      id="Polygon_39"
      data-name="Polygon 39"
      d="M4,0,8,4H0Z"
      transform="translate(8 4) rotate(180)"
    />
  ),
  upArrow: () => (
    <path
      id="Polygon_39"
      data-name="Polygon 39"
      d="M4,0,8,4H0Z"
      transform="translate(8 4)"
    />
  ),
  sale: () => (
    <path
      d="M7.4,8.3c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9S8.8,9.3,8.3,9.3S7.4,8.8,7.4,8.3z M15.7,14.8c-0.5,0-0.9,0.4-0.9,0.9
	s0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9S16.2,14.8,15.7,14.8z M24,12c0,6.6-5.4,12-12,12S0,18.6,0,12S5.4,0,12,0S24,5.4,24,12z M5.9,8.3
	c0,1.3,1.1,2.4,2.4,2.4s2.4-1.1,2.4-2.4S9.7,5.9,8.3,5.9S5.9,7,5.9,8.3z M17.2,7.9c0.3-0.3,0.3-0.8,0-1.1s-0.8-0.3-1.1,0l-9.3,9.3
	c-0.3,0.3-0.3,0.8,0,1.1c0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2L17.2,7.9z M18.1,15.7c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4
	s1.1,2.4,2.4,2.4S18.1,17,18.1,15.7z"
    />
  ),
  arrowBack: () => (
    <path
      className="st0"
      d="M15,19c-0.3,0-0.5-0.1-0.7-0.3l-6-6c-0.4-0.4-0.4-1,0-1.4l6-6c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L10.4,12l5.3,5.3
	c0.4,0.4,0.4,1,0,1.4C15.5,18.9,15.3,19,15,19z"
    />
  ),
  arrowNext: () => (
    <path
      transform="rotate(180 12,12) "
      id="svg_1"
      fill="#ffffff"
      d="m15,19c-0.3,0 -0.5,-0.1 -0.7,-0.3l-6,-6c-0.4,-0.4 -0.4,-1 0,-1.4l6,-6c0.4,-0.4 1,-0.4 1.4,0s0.4,1 0,1.4l-5.3,5.3l5.3,5.3c0.4,0.4 0.4,1 0,1.4c-0.2,0.2 -0.4,0.3 -0.7,0.3z"
      className="st0"
    />
  ),
  compare: () => (
    <path
      id="Path_88"
      d="M19.3,3.6C19.3,3.6,19.3,3.6,19.3,3.6C19.3,3.5,19.3,3.5,19.3,3.6c-0.1-0.2-0.2-0.2-0.2-0.3
	c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1L18.7,3c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0h0L13,3.5V2h-2v1.6L5.5,4.1c0,0,0,0-0.1,0
	c-0.1,0-0.2,0-0.3,0.1c0,0-0.1,0-0.1,0C5,4.3,4.9,4.3,4.8,4.4c0,0,0,0,0,0c0,0.1-0.1,0.1-0.1,0.2C4.2,5.7,0,14.7,0,17.3
	c0,3.1,2.5,5.6,5.6,5.6s5.6-2.5,5.6-5.6c0-2.2-2.8-8.5-4.1-11.4L11,5.6V7h2V5.5l3.8-0.3c-1.3,2.9-3.9,9-3.9,11.1
	c0,3.1,2.5,5.6,5.6,5.6s5.6-2.5,5.6-5.6C24,13.6,19.8,4.6,19.3,3.6z M5.6,7.5c1.2,2.7,2.3,5.4,3.2,8.2H2.3
	C3.2,12.9,4.3,10.2,5.6,7.5z M5.6,20.8c-1.8,0-3.3-1.3-3.5-3.1h7C8.9,19.5,7.4,20.9,5.6,20.8z M21.7,14.6h-6.5
	c0.9-2.8,2-5.5,3.2-8.2C19.7,9.1,20.8,11.8,21.7,14.6z M18.4,19.8c-1.8,0-3.3-1.3-3.5-3.1h7C21.8,18.4,20.2,19.8,18.4,19.8z"
    />
  ),
  description: () => (
    <path
      className="st0"
      d="M17,11H3c-0.6,0-1-0.4-1-1s0.4-1,1-1h14c0.6,0,1,0.4,1,1S17.6,11,17,11z M22,6c0-0.6-0.4-1-1-1H3
	C2.4,5,2,5.4,2,6s0.4,1,1,1h18C21.6,7,22,6.6,22,6z M22,14c0-0.6-0.4-1-1-1H3c-0.6,0-1,0.4-1,1s0.4,1,1,1h18C21.6,15,22,14.6,22,14z
	 M18,18c0-0.6-0.4-1-1-1H3c-0.6,0-1,0.4-1,1s0.4,1,1,1h14C17.6,19,18,18.6,18,18z"
    />
  ),
  specification: () => (
    <path
      className="st0"
      d="M15,8H9C8.4,8,8,8.4,8,9v6c0,0.6,0.4,1,1,1h6c0.6,0,1-0.4,1-1V9C16,8.4,15.6,8,15,8z M14,14h-4v-4h4V14z M23,13
	h-2v-3h2c0.6,0,1-0.4,1-1s-0.4-1-1-1h-2V6c0-1.7-1.3-3-3-3h-2V1c0-0.6-0.4-1-1-1s-1,0.4-1,1v2h-4V1c0-0.6-0.4-1-1-1S8,0.4,8,1v2H6
	C4.3,3,3,4.3,3,6v2H1C0.4,8,0,8.4,0,9s0.4,1,1,1h2v3H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h2v3c0,1.7,1.3,3,3,3h2v2c0,0.6,0.4,1,1,1
	s1-0.4,1-1v-2h4v2c0,0.6,0.4,1,1,1s1-0.4,1-1v-2h2c1.7,0,3-1.3,3-3v-3h2c0.6,0,1-0.4,1-1S23.6,13,23,13z M19,18c0,0.6-0.4,1-1,1H6
	c-0.6,0-1-0.4-1-1V6c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1V18z"
    />
  ),
  reviews: () => (
    <path
      className="st0"
      d="M18.8,23.5C18.8,23.5,18.8,23.5,18.8,23.5H4.5c-1.7,0-3-1.3-3-3v-7c0-1.7,1.3-3,3-3h2.4l3.7-8.4
	c0.2-0.4,0.5-0.6,0.9-0.6c2.2,0,4,1.8,4,4v3h4.7c0.2,0,0.3,0,0.5,0c0.8,0.1,1.5,0.5,2,1.2c0.5,0.6,0.7,1.4,0.5,2.2l-1.4,9
	C21.5,22.4,20.3,23.5,18.8,23.5z M8.5,21.5h10.3c0.5,0,0.9-0.4,1-0.8l1.4-9c0-0.3,0-0.5-0.2-0.7c-0.2-0.2-0.4-0.4-0.7-0.4
	c-0.1,0-0.1,0-0.2,0h-5.7c-0.6,0-1-0.4-1-1v-4c0-0.9-0.6-1.6-1.4-1.9l-3.6,8.1V21.5z M4.5,12.5c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1
	h2v-9H4.5z"
    />
  ),
  related: () => (
    <path
      className="st0"
      d="M18,23H6c-1.7,0-3-1.3-3-3V4c0-1.7,1.3-3,3-3h12c1.7,0,3,1.3,3,3v16C21,21.7,19.7,23,18,23z M6,3
	C5.4,3,5,3.4,5,4v16c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V4c0-0.6-0.4-1-1-1H6z M12,19c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5
	S14.8,19,12,19z M12,11c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S13.7,11,12,11z M13,6c0-0.6-0.4-1-1-1h0c-0.6,0-1,0.4-1,1s0.5,1,1,1
	S13,6.6,13,6z"
    />
  ),
  topArrow: () => (
    <path
      className="a"
      d="M4,5a.908.908,0,0,1-.7-.3l-3-3A.967.967,0,0,1,.3.3.967.967,0,0,1,1.7.3L4,2.6,6.3.3A.967.967,0,0,1,7.7.3a.967.967,0,0,1,0,1.4l-3,3A.908.908,0,0,1,4,5Z"
      transform="translate(8 5) rotate(180)"
    />
  ),
  bottomArrow: () => (
    <path
      className="a"
      d="M4,5a.908.908,0,0,1-.7-.3l-3-3A.967.967,0,0,1,.3.3.967.967,0,0,1,1.7.3L4,2.6,6.3.3A.967.967,0,0,1,7.7.3a.967.967,0,0,1,0,1.4l-3,3A.908.908,0,0,1,4,5Z"
    />
  ),
  minus: () => <path d="M8,0v2H0V0H8z" />,
  plus: () => <path d="M3,8V5H0V3h3V0h2v3h3v2H5v3H3z" />,
};

function SvgIcon({
  icon,
  className,
  viewBox = '0 0 24 24',
  fill,
  cursor,
  title = '',
  alt = '',
  marginLeft = 0,
  width = 24,
  height = 24,
  marginRight = 0,
  onClick = null,
}: Props) {
  const IconSrc = icons[icon];

  return (
    <IconWrapper
      cursor={cursor}
      fill={fill}
      className={className}
      viewBox={viewBox}
      onClick={onClick}
      marginLeft={marginLeft}
      marginRight={marginRight}
      width={width}
      height={height}
    >
      <title id="idTitle">{title}</title>
      <desc id="idDesc">{alt}</desc>
      <IconSrc />
    </IconWrapper>
  );
}

const IconStyles = css`
  vertical-align: middle;
`;

const IconWrapper = styled.svg<{
  fill?: string;
  cursor?: string;
  marginLeft: number;
  marginRight: number;
  width: number;
  height: number;
}>`
  ${IconStyles};
  fill: ${({ theme, fill }) => (fill ? fill : theme.colors.primary)};
  cursor: ${({ cursor }) => (cursor ? cursor : 'initial')};
  transition: fill 0.2s ease;
  margin-left: ${props => rem(props.marginLeft)};
  margin-right: ${props => rem(props.marginRight)};
  width: ${props => rem(props.width)};
  height: ${props => rem(props.height)};
`;

const IconPath = styled.path``;

export { SvgIcon as DsiSvgIcon };
